import IconInfoSvg from '../../../images/IconEdit.svg';
import React from 'react';

export default function IconEdit({className, ...other}) {
	return <img className={`${className ? className : ''}`} src={IconInfoSvg} alt="Icon Info SVG" {...other}/>
}
